export const discordConnected = (membership) =>
  membership?.connected === true &&
  /^https:\/\/discord\.com\/channels\/\d+\/\d+$/.test(
    String(membership?.destination || "")
  );

export const discordActionLabel = (membership) =>
  discordConnected(membership) ? "Open PWG Discord" : "Join PWG Discord";
